import { z } from "zod";
import { Id, NonEmpty } from "../base";
import { TimestampSchema } from "../epoch";
export const ReferralStatusSchema = z.enum([
    "claimed",
    "qualified",
    "validated",
]);
export const ReferralClaimInputSchema = z.object({
    code: z
        .string()
        .trim()
        .min(6)
        .max(64)
        .regex(/^[A-Z0-9]+$/, "Referral code must be uppercase alphanumeric"),
});
export const ReferralRecordSchema = z.object({
    id: Id,
    referrerUserId: Id,
    referredUserId: Id,
    referralCode: z.string().min(6).max(64),
    status: ReferralStatusSchema,
    claimedAt: TimestampSchema,
    firstQualifiedAt: TimestampSchema.nullable(),
    instantBonusAwardedAt: TimestampSchema.nullable(),
    validatedAt: TimestampSchema.nullable(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const ReferralMilestoneViewSchema = z.object({
    id: z.string().min(1).max(32),
    title: NonEmpty.max(120),
    description: NonEmpty.max(240),
    target: z.number().int().min(1),
    current: z.number().int().min(0),
    rewardBlocks: z.number().int().min(0),
    completed: z.boolean(),
});
export const ReferralUserViewSchema = z.object({
    userId: Id,
    displayName: z.string().min(1).max(120),
    avatarUrl: z.string().nullable(),
    joinedAt: TimestampSchema,
    blockBalance: z.number(),
    approvedQuestCount: z.number().int().min(0),
    status: ReferralStatusSchema,
    claimedAt: TimestampSchema,
    firstQualifiedAt: TimestampSchema.nullable(),
    validatedAt: TimestampSchema.nullable(),
});
export const ReferralProgramViewSchema = z.object({
    referralCode: z.string().min(6).max(64),
    stats: z.object({
        totalClaimed: z.number().int().min(0),
        qualified: z.number().int().min(0),
        validated: z.number().int().min(0),
        bonusBlocksEarned: z.number().int().min(0),
    }),
    milestones: z.array(ReferralMilestoneViewSchema),
    referredUsers: z.array(ReferralUserViewSchema),
});
export const ReferralClaimResultSchema = z.object({
    referrerUserId: Id,
    referrerDisplayName: z.string().min(1).max(120),
    referralCode: z.string().min(6).max(64),
    status: ReferralStatusSchema,
});
